import request from "@/utils/request";

// 获取城市列表
export function getCityList() {
  return request({
    url: "/open/city/list",
    method: "get",
  });
}

// 获取区域列表
export function getAreaList() {
  return request({
    url: "/open/area/list",
    method: "get",
  });
}

// 获取开放区域及路线列表
export function getRoutes(categoryCode) {
  return request({
    url: "/open/area/routes?categoryCode=" + categoryCode,
    method: "get",
  });
}


//开发测试道路
export function getOpenRoads(params) {
  return request({
    url: "/open/info/routes",
    method: "post",
    data: params
  });
}

// 开发测试道路列表
export function getRoutesList() {
  return request({
    url: "/open/routes/list",
    method: "get",
  });
}